import { AccountsAgencyPartnerChoices } from "../graphql/generated";

export const humanInTheLoopAccess = [
    AccountsAgencyPartnerChoices.NewsUk,
    AccountsAgencyPartnerChoices.IrishTimes,
    AccountsAgencyPartnerChoices.Demo
  ];
  
export const hitlPredictionsAccess = [AccountsAgencyPartnerChoices.NewsUk];